<template>
	<div>
		<div v-if="loading>0">
			<div class="text-center" v-if="loading>0">
				<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
			</div>
		</div>
		<b-alert v-else-if="!!error" variant="danger" show>{{error}}</b-alert>
		<div v-else-if="user">
			<b-form-checkbox switch v-model="user.public_page_status" @change="saveUserData()" value="enabled" unchecked-value="disabled">Enable public profile page</b-form-checkbox><br />
			<div v-if="user.public_page_status == 'enabled'">Page URL: <a :href="`${$baseUrl}/user/${user.username}/voices`" target="_blank">{{$baseUrl}}/user/{{user.username}}/voices</a></div>
		</div>
		<div v-else>
			No userdata found.
		</div>
	</div>
</template>

<script>
export default {
	data: () => ({
		loading: 0,
		error: null,
		user: null,
	}),
	created() {
		this.loadUserData();
	},
	methods: {
		async loadUserData() {
			try {
				this.error = null;
				this.loading++;
				this.user = await this.$api.get('userData');
			} catch(e) {
				console.error('Could not load user data for Profile page', e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async saveUserData() {
			try {
				this.error = null;
				this.loading++;
				await this.$api.post('userData', { public_page_status: this.user.public_page_status });
				this.$bvToast.toast('Successfully saved public page status', { title: 'Success', variant: 'success', solid: true });
			} catch(e) {
				console.error('Could not save user data for Profile page', e);
				this.$bvToast.toast('Could not save public page status: ' + e.toString(), { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.loading--;
			}
		},
	}
}
</script>
